import { REQUEST_STATUS } from '../../../../shared/api/hscan/hospital';

export const mapStatusForRequest = (status?: REQUEST_STATUS) => {
  return status === 'CANCELLED' ? 'AVAILABLE' : status ?? 'AVAILABLE';
};
